/**
 * Used to DRY OAuthConfiguration
 */
export const OAuthConfig = {
  Scope: "https://www.googleapis.com/auth/gmail.send",
  FlowType: "auth-code",
};
